<template>

    <div class="login-oauth">
        <page-loader ref="loader"></page-loader>
        <div class="steps">1 / 2</div>
        <modal-error-provider ref="MEP" :email="emailError"  @close="errorPopupClosed"></modal-error-provider>
        <modal-login-long-fail ref="MLLF" @close="errorPopupClosed"></modal-login-long-fail>
        <modal-outlook-invalid-credentials ref="MOIC" :simple="true" @close="errorPopupClosed"></modal-outlook-invalid-credentials>

    </div>

</template>

<script>



// import Auth from '../modules/auth'
// import SessionStorage from '@/helpers/sessionStorage'
// import Login from '../modules/login'
import OAuthMicrosoft from '../modules/o-auth/microsoft'
import { configuration } from '../../configuration'

import PageLoader from '../components/PageLoader'
import ModalErrorProvider from '../components/modal/ModalErrorProvider'
import ModalLoginLongFail from '../components/modal/ModalLoginLongFailed'
import ModalOutlookInvalidCredentials from '../components/modal/ModalOutlookInvalidCredentials'


export default {

    name: 'login-o-auth',
    components: {
        PageLoader,
        ModalErrorProvider,
        ModalLoginLongFail,
        ModalOutlookInvalidCredentials
    },

    data() {
        return {
            emailError: '',
            provider: 'microsoft'
        }
    },

    async mounted() {

        await this.initData()

    },

    methods: {


        errorPopupClosed() {
            this.$router.go(-1)
        },


        async initData() {

            // TODO: currently only Microsoft is supported

            const { email } = OAuthMicrosoft.getOAuthStep1Data()
            this.$refs.loader.start()

            // Navigate to the Microsoft server to initiate the login process and get in return the authenticate code

            const scopeUrlStr = configuration.oauth.microsoft.scope.replace(/ /g, '%20')

            const loginMicrosoft = ['https://login.microsoftonline.com/common/oauth2/v2.0/authorize?',
                `client_id=${configuration.oauth.microsoft.clientId}`,
                '&response_type=code',
                `&redirect_uri=${configuration.oauth.microsoft.redirectUri}`,
                '&response_mode=query',
                `&scope=${scopeUrlStr}`,
                '&state=step1',
                `&login_hint=${email}`,
                `&code_challenge=${OAuthMicrosoft.generateCodeChallenge()}`,
                '&code_challenge_method=S256'
            ]

            window.location.href = loginMicrosoft.join('')

            this.$refs.loader.stop()

        }
    }
}
</script>

<style lang="scss" scoped>

.steps {
    font-size: smaller;
    margin-top: auto;
    margin-bottom: auto;
}


</style>